// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

const state = {
	categorilasFiltro: [],
	buscadorPresentacionesRanged: null,
	reduceUiRendimiento: true,
	estatusPedido: {
		1: "Registrado",
		2: "En proceso",
		3: "Armado",
		4: "Entregado",
		6: "Cancelado"
	},
	compartirConf: [
		{value: 'c', text: 'Cliente'},
		{value: 't', text: 'Temporal'},
		{value: 'p', text: 'Público'},
		{value: 'o', text: 'Oculto en las listas'},
	]
}

const getters = {
	uiGetReduceUiRendimiento: state => { return state.reduceUiRendimiento },
	uiGetCategoriasFiltro: (state) => { return state.categorilasFiltro },
	uiGetBuscadorPresentacionRangedCfg: (state) => { return state.buscadorPresentacionesRanged },
	uiGetCompartirConf: state => { return state.compartirConf },
	uiGetEstatusPedido: (state) => {
		return _.map(state.estatusPedido, (text, value) => {
			return {
				value,
				text,
				disabled: false
			};
		})
	}
}

const mutations = {
	uiSetReduceUiRendimiento: (state, payload) => {
		state.reduceUiRendimiento = payload
	},
	uiSetBuscadorPresentacionRangedCfg: (state, payload) => {
		state.buscadorPresentacionesRanged = payload
	},
	uiSetCategoriasFiltro: (state, payload) => {
		state.categorilasFiltro = payload
	}
}

const actions = {
	updateCategoriasFiltro: async ({commit}) => {
		try {
			const response = await axios.get('monitorcompraventa/getcats')
			if(response.status){
				commit('uiSetCategoriasFiltro', response.data)
			}
		} catch(e) {
			console.error(e)
			mobiscroll.snackbar({
				display: 'top',
				theme: 'ios',
				message: 'Ocurrió un error la lista completa de cateogiras: ' + e,
				color: 'warning',
				duration: 7000
			})
		}
	}
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};
